// 入口
// 文件都会汇聚到这个地方来,也是创建store对象的地方,就像store的入口一样
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import UserInfo from "./modules/user";
import UserInitInfo from "./modules/store";
import IMframe from "./modules/IMframe";
/* import Common from "./modules/common";
import Live from "./modules/liveModules";
import Honghong from "./modules/honghong"; */

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    UserInfo,
    IMframe,
    /* Common,
    Live,
    Honghong, */
    UserInitInfo
  },
  getters
});

export default store;
